import React from "react";
import { cn } from "../../lib/cn";

/**
 * Card - white bg, rounded-card, shadow-card, bordered container.
 * @param {string} [className]
 * @param {React.ReactNode} children
 */
export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn(
        "rounded-card border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 shadow-card dark:shadow-black/20",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * CardHeader
 * @param {string} [className]
 * @param {React.ReactNode} children
 */
export function CardHeader({ className, children, ...props }) {
  return (
    <div className={cn("border-b border-neutral-200 dark:border-neutral-800 px-6 py-4", className)} {...props}>
      {children}
    </div>
  );
}

/**
 * CardTitle
 * @param {string} [className]
 * @param {React.ReactNode} children
 */
export function CardTitle({ className, children, ...props }) {
  return (
    <h3 className={cn("text-base font-semibold text-neutral-900 dark:text-neutral-100", className)} {...props}>
      {children}
    </h3>
  );
}

/**
 * CardContent
 * @param {string} [className]
 * @param {React.ReactNode} children
 */
export function CardContent({ className, children, ...props }) {
  return (
    <div className={cn("px-6 py-4", className)} {...props}>
      {children}
    </div>
  );
}

/**
 * CardFooter
 * @param {string} [className]
 * @param {React.ReactNode} children
 */
export function CardFooter({ className, children, ...props }) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 border-t border-neutral-200 dark:border-neutral-800 px-6 py-4",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
